import * as Config from '../../config/config';

import noun_close_4213500copy from '../../assets/images/noun_close_4213500_copy.png';
import { useState } from 'react';
import { getFieldByLangKey } from "../utils/LanguageField";

export default function ProductItem(props) {
    const customer = props.customer;
    const imageUrl = Config.MEDIA_URL+Config.WHATSUP_IMAGE_FOLDER+props.image;
    let popupimageUrl;
    if (props.popup_image) {
    popupimageUrl = Config.MEDIA_URL + Config.WHATSUP_IMAGE_FOLDER + props.popup_image;
    }
    const [active, setActive] = useState(false);
    const [disable, setDisable] = useState(false);
    
    const popupClick = (event) => {
        // Check if the event originates from the specific <a> inside the popup
        const isInsidePopupAnchor = event.target.closest('.pop-up a');
        document.body.classList.add("active");
        if (isInsidePopupAnchor) {
            setDisable(true); // Add 'disable' class
            document.body.classList.remove("active");
        } else {
            setDisable(false); // Remove 'disable' class if clicked elsewhere
        }

        setActive((prevActive) => !prevActive);
    };

    const titleField = getFieldByLangKey('title');
    const textField = getFieldByLangKey('text');

    // Generate the dynamic class name
    const parentClassName = `landingbx ${active ? 'active' : ''} ${disable ? 'disable' : ''}`.trim();


    return (   
        <div className={parentClassName}>
            <a href="#" title={props[titleField]} className='product-name' onClick={popupClick} >
                <img src={imageUrl} className="landingimg" alt={props[titleField]}/>
            </a>
            <div className="landingbx_popup">
                <div className="pop-up">
                    <div className="pop-upcol">  
                        <a href='#' onClick={popupClick}>
                            <img src={noun_close_4213500copy} className="pop-up-closed noun_close_4213500-copy" alt="" width="17" height="17"/>
                        </a>
                        <h2>{props[titleField]}</h2>
                        <div className='announcement-content'>
                            <p>Dear {customer && customer?.person_incharge}, {props[textField]}</p>
                            {popupimageUrl && <img src={popupimageUrl} className="layer-35" alt={props[titleField]} width="331" />}
                        </div>                        
                    </div>
                </div>
            </div>            
        </div>
    );
}
